import discountReducer from '../reducers/discounts'

export function setDiscountId(id) {
	return async (dispatch) => {
		dispatch(discountReducer.Creators.setDiscountId(id))
	}
}

export function setDiscount(discount) {
	return async (dispatch) => {
		dispatch(discountReducer.Creators.setDiscount(discount))
	}
}
